import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { MetaDefinition } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { JournalService } from '@journal/core/api/journal/journal.service';
import { environment } from '@journal/env/environment';
import { UNI_CONSTANTS } from '@sparro/app/core/config/constants.config';
import { ImageOptimizerService } from '@sparro/app/core/helpers/image-optimizer';
import { MetaService } from '@sparro/app/core/helpers/meta/meta.service';
import { Blog } from '@sparro/app/core/models/blog.model';
import { Badge, Slide } from '@sparro/app/core/models/carousel.model';
import { PaginatedBlog } from '@sparro/app/core/models/blog.model';
import { MatSidenav } from '@angular/material/sidenav';
import { Competition } from '@sparro/app/core/models/competition.model';
import _ from 'lodash';
import { SuperTag } from '@sparro/app/core/models/supertag.model';
import { BreakpointObserver } from '@angular/cdk/layout';
import { BREAKPOINTS } from '@sparro/app/core/config/constants.config';

export class SEOContent {
  title: string;
  content: string;
}

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})

export class HomeComponent implements OnInit {
  blogs = [];
  featuredBlogs: Blog[] = [];
  UNIBlogs: Blog[] = [];
  adsArray: any[] = [];
  editorialBlogs = [];
  seoContent: SEOContent;
  blogType: any = null;
  blogTypes: any = [];
  competitions: Competition[] = [];
  next: any = 1;
  page: number = 1;
  isLoading = true;
  showSpinner = false;
  tabView: boolean = false;
  carousel: Array<Slide> = [];
  host: string = UNI_CONSTANTS.HOSTS.BLOG;
  topSuperTags: SuperTag[] = [];
  viewportHeight: number = 0;
  editorialPage: number = 1;
  allEditorialLoaded: boolean = false;
  disciplineId: number = null;
  blogTypeUrl: string = `${environment.postUrl}type/`;
  topicUrl: string = `${environment.topicUrl}`;
  journalUrl: string = `${environment.postUrl}`;
  isVerticallyScrollable: boolean = true;
  showScroll: boolean = false;
  blogCreateUrl: string = `${environment.postUrl}edit/`

  @ViewChild('sidenavContainer') sidenav: ElementRef;
  @ViewChild('tabsContent') tabsContent: ElementRef;
  @ViewChild('chipSection') chipList: ElementRef;
 
  constructor(
    public metaService: MetaService,
    public router: Router,
    public route: ActivatedRoute,
    private blogService: JournalService,
    private breakpointObserver: BreakpointObserver,
    private imageOptimizer: ImageOptimizerService
  ) {}

  ngOnInit(): void {
    // this.getUniBlogs();
    this.blogType = this.route.snapshot.params.blogType;
    this.getAds();
    this.getBlogTypes();
    this.initializeBreakpoints();
  }

  openCreateBlogUrl() {
    this.router.navigate
  }

  initializeBreakpoints() {
    this.breakpointObserver.observe([
      BREAKPOINTS.below.lg
    ]).subscribe(result => {
      this.tabView = Boolean(result.breakpoints[BREAKPOINTS.below.lg]);
    });
  }

  getTopSuperTags() {
    this.blogService.getTopBlogSuperTags().subscribe((res: SuperTag[]) => {
      this.topSuperTags = res;
    })
  }

  getCompetitions() {
    this.blogService.getBlogTypeCompetitions().subscribe((res: any) => {
      this.competitions = res.results.slice(0, 2);
    }, err => {
      console.log(err);
    })
  }

  getBlogTypes(): void {
    this.blogService.getBlogTypes().subscribe((res: any)=> {
      if (res) {
        this.blogTypes = _.orderBy(res.results, ['name'], ['asc']);
        if (this.blogType) {
          const blogType = this.blogTypes.filter(type => {
            if (type.slug==this.blogType) {
              return type;
            }
          })
          if (blogType?.length && blogType[0]?.slug==this.blogType){
            this.disciplineId = blogType[0].id;
            this.getEditorialBlogs();
          } else {
            this.router.navigate(['error'], {queryParams: { type: '404' }});
          }
        } else {
          this.getEditorialBlogs();
          this.getTopSuperTags();
          this.getCompetitions();
          this.getSeoContent();
        }
        this.getFeaturedBlogs();
      }
    })
  }

  getSeoContent(): void {
    this.blogService.getSeoContent().subscribe(
      (response: SEOContent) => {
        this.seoContent = response;
      }
    )
  }

  getAds() {
    this.blogService.getAd('Journal').subscribe((response: any) => {
      if (response) {
        this.adsArray = _.shuffle(response);
      }
    }, error => {
      console.log(error);
    })
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(): void {
    if (this.sidenav) {
      this.sidenav.nativeElement.style.top = `-${(this.sidenav.nativeElement.offsetHeight + 10) - window.innerHeight}px`;
      }

    const currentPos = (document.documentElement.scrollTop || document.body.scrollTop);
    const maxPos = document.documentElement.scrollHeight;
    if (currentPos >= maxPos / 3 && this.next && !this.showSpinner && this.allEditorialLoaded) {
      this.loadMore();
    }
    if (currentPos >=maxPos / 3 && !this.allEditorialLoaded && !this.showSpinner) {
      this.loadEditorialBlogs();
    }

    this.showScroll = Boolean(this.tabsContent.nativeElement.offsetWidth < this.chipList.nativeElement.offsetWidth && window.innerWidth > 960);
    this.tabsContent.nativeElement.style.overflow = window.innerWidth <= 960 ? 'scroll' : 'hidden';
  }

  loadEditorialBlogs() {
    if (!this.allEditorialLoaded && !this.showSpinner) {
      this.getEditorialBlogs();
    }
  }

  getFeaturedBlogs(): void {
    this.blogService.getB2BBlogs().subscribe(
      (response: Blog[]) => {
        this.featuredBlogs = response;
        this.updateMetaInfo();
      },
      (err) => {
        console.log(err);
      });
  }

  getUniBlogs(): void {
    this.blogService.getBlogsByUserId(this.page, 944).subscribe(
      (response: PaginatedBlog) => {
        this.UNIBlogs = [...this.blogs, ...response.results];
        this.getBlogs();
      },
      (err) => {
        console.log(err);
      });
  }

  getEditorialBlogs(): void {
    if (!this.showSpinner) {
      this.showSpinner = true;
    }
    this.blogService.getEditorialBlogs(this.editorialPage, this.disciplineId).subscribe(
      (response: PaginatedBlog) => {
        this.editorialBlogs.push(response.results);
        const section_next = response.next;
        if (section_next) {
          this.editorialPage = parseInt(section_next.split('=')[2]);
        } else {
          this.allEditorialLoaded = true;
        }
        this.isLoading = false;
        this.showSpinner = false;
      },
    (err) => {
      console.log(err);
      this.isLoading = false;
      this.showSpinner = false;
    });
  }

  getBlogs(): void {
    if (!this.showSpinner) {
      this.showSpinner = true;
    }
    this.blogService.getFeedBlogs(this.page, this.disciplineId).subscribe(
      (response: any) => {
        this.blogs.push(response.results);
        this.next = response.next;
        if (this.next) {
          this.page = parseInt(this.next.split('=')[this.disciplineId ? 2 : 1]);
        }
        this.isLoading = false;
        this.showSpinner = false;
      },
    (err) => {
      console.log(err);
      this.isLoading = false;
      this.showSpinner = false;
    });
  }


  loadMore(): void {
    this.showSpinner = true;
    this.getBlogs();
  }

  scroll(direction) {
    if (direction == "left") {
      this.tabsContent.nativeElement.scrollLeft -= 150;
    }
    else {
      this.tabsContent.nativeElement.scrollLeft += 150;
    }
  }

  updateMetaInfo(): void {
    let metaInfo: MetaDefinition[] = [];
    const title = 'Architecture & Design  News | Publish your news & blogs';
    const description = `Get your news published and read by a growing community of architecture and design professionals`;
    const image = '';
    metaInfo = [
      { name: 'title', content: title },
      { name: 'description', content: description },
      { name: 'url', content: window.location.href },
      { name: 'image', content: image },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: title },
      { name: 'twitter:description', content: description },
      { name: 'twitter:url', content: window.location.href },
      { name: 'twitter:image', content: image },
      { property: 'og:title', content: title },
      { property: 'og:description', content: description },
      { property: 'og:url', content: window.location.href },
      { property: 'og:image', content: image },
      { property: 'og:image:alt', content: title },
      { property: 'og:type', content: 'website' }
    ];
    metaInfo.forEach(meta => {
      this.metaService.updateMetaInfo(meta);
    });
    this.metaService.updateMeta(metaInfo);
    this.metaService.updateTitle(title);
    this.metaService.createCanonicalURL();
  }

  renderImage(image: string): string {
    return this.imageOptimizer.renderImage(image, window.innerWidth, '');
  }

  goToSearchPage(searchText: (string | void)): void {
    if (searchText) {
      this.router.navigate(['search'], {
        queryParams: {
          query: searchText,
        },
      });
    }
    else {
      this.router.navigate(['search']);
    }
  }
}
